<template>
    <div class="modal fade onloadmodel-main" id="instructionsModal" tabindex="-1" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog modal-lg onload-modal modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <section class="sub-header-wrapper" v-if="hasRules">
                        <div class="sub-header-tab">
                            <div class="container">
                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                    <template v-for="(value, lang) in messages" :key="lang">
                                        <li class="nav-item" role="presentation" v-if="value && value.length > 0">
                                            <button class="nav-link" :class="{ active: lang === activeLanguage }" :id="`pills-${lang}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${lang}`"
                                                type="button" role="tab" :aria-controls="`pills-${lang}`" :aria-selected="lang === activeLanguage" @click="activeLanguage = lang">
                                                {{ lang  }}
                                            </button>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>

                        <div class="sub-header-tab-con">
                            <div class="container">
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active"  v-for="(message, lang) in messages" 
                                    :key="lang" v-show="lang === activeLanguage"   :id="`pills-${lang}`" role="tabpanel" :aria-labelledby="`pills-${lang}-tab`">
                                        <template v-if="message && message?.length > 0">
                                            <div class="language-list" v-for="(rule,index) in message" :key="index" >
                                                <p v-html="rule?.description"></p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="sub-header-wrapper" v-else>
                        <div class="sub-header-tab">
                            <div class="container">
                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" :id="`pills-general-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-general`"
                                            type="button" role="tab" :aria-controls="`pills-general`" aria-selected="true" >
                                            General rules
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="sub-header-tab-con">
                            <div class="container">
                                <div class="tab-content" id="pills-tabContent">
                                    <div v-if="instructionType == 'deposit'" class="tab-pane fade show active" :id="`pills-general`" role="tabpanel" :aria-labelledby="`pills-general-tab`">
                                        <div class="language-list">
                                            <p>{{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</p>
                                        </div>  
                                        <div class="language-list">
                                            <p>{{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</p>
                                        </div>  
                                        <div class="language-list">
                                            <p>{{ $t('deposits-made-45-minutes-after-the-account', 'Deposits made 45 minutes after the account removal from the site are valid & will be added to their wallets') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('site-is-not-responsible-for-money', 'Site is not responsible for money deposited to Old, Inactive or Closed accounts') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('after-deposit-add-your-utr-and-amount', 'After deposit, add your UTR and amount to receive balance') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('neft-receiving-time-varies', 'NEFT receiving time varies from 40 minutes to 2 hours') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('in-case-of-account-modification', 'In case of account modification: payment valid for 1 hour after changing account details in deposit page') }}.</p>
                                        </div>
                                    </div>
                                    <div v-else class="tab-pane fade show active" :id="`pills-general`" role="tabpanel" :aria-labelledby="`pills-general-tab`">
                                        <div class="language-list">
                                            <p> {{ $t('this-form-is-for-withdrawing-the-amount', 'This form is for withdrawing the amount from the main wallet only') }}.</p>
                                        </div>  
                                        <div class="language-list">
                                            <p> {{ $t('the-bonus-wallet-amount-cannot-be-withdrawn', 'The bonus wallet amount cannot be withdrawn by this form') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('do-not-put-withdraw-request-without-betting-with', 'Do not put Withdraw request without betting with deposit amount. Such activity may be identified as Suspicious') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p> {{ $t('If-multiple-users-are-using-same-withdraw', 'If multiple users are using same withdraw account then all the linked users will be blocked') }}.</p>
                                        </div>
                                        <div class="language-list">
                                            <p>{{ $t('maximum-withdraw-time-is-45-minutes-then-only-complain', 'Maximum Withdraw time is 45 minutes then only complain on WhatsApp number') }}.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="modal-footer border-0">
                    <button type="button" class="onloadclosebtn thm-but border-0" data-bs-dismiss="modal">Back</button>
                    <button type="button" class="thm-but border-0" data-bs-dismiss="modal"
                        @click="actionMethod">Proceed
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['walletConfig'],
    mounted(){
        if (this.messages) {
            this.activeLanguage = Object.entries(this.messages).find(([lang, rules]) => rules.length > 0)?.[0] || null;
        }
    },
    data() {
        return {
            activeLanguage: null,
        };
    },
    computed: {
        messages() {
            return this.walletConfig?.rules?.[this.instructionType] || null;
        },
        hasRules() {
            if (!this.messages) return false;
            return Object.values(this.messages).some(arr => arr && arr.length > 0);
        }
    },
    props: ['instructionType', 'actionMethod']
};
</script>
<style scoped>
.language-list li {
    list-style: none;
}
</style>